import { combineReducers } from 'redux';
import auth from '@app/modules/auth/redux';
import features from '@app/modules/features/redux';
import apiConnectivity from './api-connectivity';
import time from './time';
import orders from './orders';
import user from './user';
import featureToggles from './feature-toggles';
import firebase from './firebase';
import dealer from './dealer';
import reminders from './reminders';
import notifications from './notifications';
import toasts from './toasts';
import form from './form';
import orderHistory from './order-history';
import orderEventHistory from './order-event-history';
import orderSound from './order-sound';
import drivers from './drivers';

const rootReducer = combineReducers({
  apiConnectivity,
  time,
  orders,
  user,
  featureToggles,
  firebase,
  dealer,
  reminders,
  toasts,
  notifications,
  form,
  orderHistory,
  orderEventHistory,
  orderSound,
  drivers,
  auth,
  features,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js